/**
 * Shared People-leaf chrome (TMMPDM-0085). Customers' table surface and toolbar
 * (search beside the invite control, not pushed to the far edge) are the model.
 */
import type { ReactNode } from 'react';
import { Paper, Stack, TableContainer } from '@mui/material';

export function PeopleLeafLayout({
  caption,
  invitations,
  children,
}: {
  caption: ReactNode;
  invitations: ReactNode;
  children: ReactNode;
}) {
  return (
    <Stack spacing={2}>
      {caption}
      {invitations}
      {children}
    </Stack>
  );
}

/** Search and the invite control share this row. */
export function PeopleToolbar({ children }: { children: ReactNode }) {
  return (
    <Stack
      data-testid="people-toolbar"
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      sx={{ alignItems: { sm: 'center' }, mb: 2 }}
    >
      {children}
    </Stack>
  );
}

export function PeopleTableContainer({
  children,
  busy = false,
}: {
  children: ReactNode;
  busy?: boolean;
}) {
  return (
    <TableContainer component={Paper} variant="outlined" aria-busy={busy ? 'true' : 'false'}>
      {children}
    </TableContainer>
  );
}
